import http from "./httpService";

const apiEndpoint = "/our-portfolio";

export function getPortfolioTaxonomy() {
  return http.get(apiEndpoint);
}
